import { ConfigurationDto, ConfigurationService } from '@/api-sdk';
import {
  GlobalComponentType,
  PersonalisationType,
  PrintExampleType,
  personalisation,
  printExample,
} from '@/context';

/**
 * Saves the configuration and associated contexts, then executes a callback with the configuration ID.
 *
 * @param globalContext - The global context containing debtor, country, layout, and locale.
 * @param personalisationContext - Optional personalisation context array.
 * @param printExampleContext - Optional print example context.
 * @param configuration - The configuration data to be saved.
 * @param callback - The callback function to be executed with the configuration ID.
 */
export const saveConfiguration = async ({
  globalContext,
  personalisationContext,
  printExampleContext,
  configuration,
  callback,
}: {
  globalContext: GlobalComponentType;
  personalisationContext?: PersonalisationType[];
  printExampleContext?: PrintExampleType;
  configuration: ConfigurationDto;
  callback: (configurationId: string) => void;
}) => {
  const { debtor, country, layout, locale } = globalContext;

  const configurationId = await ConfigurationService.postSaveConfiguration({
    debtor: layout === 'wholesale' ? debtor : undefined,
    country,
    requestBody: configuration,
  });

  if (configurationId) {
    if (personalisationContext) {
      await personalisation.save(
        personalisationContext,
        configurationId,
        locale,
      );
    }
    if (printExample) {
      await printExample.save(printExampleContext, configurationId);
    }
    callback(configurationId);
  }
};
